import amplitude from 'amplitude-js';
import store from '@/store';

export const logAmplitudeEvent = (eventName, data = {}, companyId = null) => {
  const {user, providerType} = store.getters;

  const eventData = {
    user_id: user?.id || null,
    company_id: companyId,
    timestamp: new Date().toISOString(),
    product_package: providerType,
    ...data,
  };

  if (window.isDev) return;

  const instance = amplitude.getInstance();
  if (companyId) {
    instance.setGroup('company_id', companyId);
  }
  instance.logEvent(eventName, eventData);
};

export default amplitude;
